<template>
  <div v-if="isAddress2">
    <template
      v-if="
        addressList.length === 0 &&
        fqdnList.length === 0 &&
        countryList.length === 0
      "
      >any</template
    >
    <template v-else>
      <p v-for="(e, i) in addressList" :key="`address_${i}`">
        {{ e.ipAddressName ? e.ipAddressName : e.ipAddress }}
      </p>
      <p v-for="(e, i) in fqdnList" :key="`fqdn_${i}`">
        {{ e.fqdnName ? e.fqdnName : e.fqdn }}
      </p>
      <p v-for="(e, i) in countryList" :key="`country_${i}`">
        {{ e.country }}
      </p>
    </template>
  </div>
  <div v-else>
    <template v-if="addressList.length === 0">any</template>
    <template v-else>
      <p v-for="(e, i) in addressList" :key="`address_${i}`">
        {{ e.ipAddressName ? e.ipAddressName : e.ipAddress }}
      </p>
    </template>
  </div>
</template>

<script lang="ts">
import type { PropType } from "vue";
import { defineComponent } from "vue";
import type { GetDstAddress1, GetDstAddress2 } from "@/apis/NwPolicyApi";

/** インターネットType1,4のポリシーの送信先アドレス表示が出来るコンポーネント */
export default defineComponent({
  name: "PolicyDstAddress",
  props: {
    /** 送信先アドレス */
    dstAddress: {
      type: Object as PropType<GetDstAddress1 | GetDstAddress2>,
      required: true,
    },
  },
  computed: {
    /** true: GetDstAddress2, false: GetDstAddress1 */
    isAddress2(): boolean {
      return (
        "dstFqdnList" in this.dstAddress && "dstCountryList" in this.dstAddress
      );
    },
    /** アドレス一覧を昇順でソートした一覧 */
    addressList(): GetDstAddress2["dstAddressList"] {
      return [
        ...this.dstAddress.dstAddressList
          .filter((e) => e.ipAddress && !e.ipAddressName)
          .sortBy(["ipAddress", "asc"]),
        ...this.dstAddress.dstAddressList
          .filter((e) => e.ipAddressName)
          .sortBy(["ipAddressName", "asc"]),
      ];
    },
    /** FQDN一覧を昇順でソートした一覧. GetDstAddress2では無い場合は空 */
    fqdnList(): GetDstAddress2["dstFqdnList"] {
      if (this.isAddress2) {
        return (this.dstAddress as GetDstAddress2).dstFqdnList.sortBy([
          (e) => e.fqdnName ?? e.fqdn,
          "asc",
        ]);
      } else {
        return [];
      }
    },
    /** 国一覧を昇順でソートした一覧. GetDstAddress2では無い場合は空 */
    countryList(): GetDstAddress2["dstCountryList"] {
      if (this.isAddress2) {
        return (this.dstAddress as GetDstAddress2).dstCountryList.sortBy([
          "country",
          "asc",
        ]);
      } else {
        return [];
      }
    },
  },
});
</script>

<style scoped lang="scss">
p {
  margin: 0;
}
</style>
